import React from 'react';

// Estilos CSS en objetos
    const containerStyle = {
        maxWidth: '900px',
        margin: '0 auto',
        padding: '20px',
        color: '#333',
        lineHeight: '1.6',
        fontSize: '20px' // Tamaño de fuente 12px para todo el contenido
    };

    const titleStyle = {
        textAlign: 'center',
        fontSize: '25px', // Título ligeramente más grande pero manteniendo proporción
        fontWeight: 'bold',
        marginBottom: '15px',
        paddingBottom: '10px',
    };

    const sectionStyle = {
        marginBottom: '20px',
        padding: '15px',
        borderRadius: '5px',
    };

    const headingStyle = {
        fontWeight: 'bold',
        marginBottom: '10px',
        fontSize: '20px' // Tamaño de fuente 12px para los encabezados
    };

    const listStyle = {
        paddingLeft: '15px',
        marginBottom: '10px'
    };

    const listItemStyle = {
        marginBottom: '6px',
        fontSize: '16px' // Tamaño de fuente 12px para items de lista
    };

    const paragraphStyle = {
        marginBottom: '10px',
        fontSize: '16px' // Tamaño de fuente 12px para párrafos
    };

    const noteStyle = {
        padding: '12px',
        borderRadius: '5px',
        borderLeft: '4px solid #f59e0b',
        marginTop: '20px',
        fontWeight: 'bold',
        color: '#b45309',
        fontSize: '16px', // Tamaño de fuente 12px para la nota
    };

    const contactInfoStyle = {
        color: '#2b6cb0',
        fontWeight: 'bold',
        fontSize: '16px' // Tamaño de fuente 12px para información de contacto
    };

const PoliticsEN = () => {
    return (
        <div style={containerStyle}>
            <h1 style={titleStyle}>RETURN POLICY AND PROCESS</h1>
            
            <section style={sectionStyle}>
                <h2 style={headingStyle}>Objective:</h2>
                <p style={paragraphStyle}>
                    To guarantee a satisfactory customer experience by managing product returns efficiently,
                    quickly and fairly, considering that every approved return goes hand in hand with a prior product review.
                </p>
            </section>
            
            <section style={sectionStyle}>
                <h2 style={headingStyle}>1. Return Period and General Conditions:</h2>
                <p style={paragraphStyle}>
                    For a return to apply, it must meet the following criteria:
                </p>
                <ul style={listStyle}>
                    <li style={listItemStyle}>The return is requested within 15 calendar days after the product delivery date.</li>
                    <li style={listItemStyle}>The product must be new, unused and not installed.</li>
                    <li style={listItemStyle}>The product must be in its original packaging, with user manuals, labels and complete accessories.</li>
                    <li style={listItemStyle}>The packaging must be in good condition.</li>
                    <li style={listItemStyle}>In case of defective or damaged products, photographic evidence must be provided.</li>
                    <li style={listItemStyle}>Labeling error or if the description does not match the delivered product.</li>
                </ul>
            </section>
            
            <section style={sectionStyle}>
                <h2 style={headingStyle}>2. Returns do not apply if:</h2>
                <ul style={listStyle}>
                    <li style={listItemStyle}>The product was damaged due to misuse or accident.</li>
                    <li style={listItemStyle}>If the packaging is damaged and/or scratched.</li>
                    <li style={listItemStyle}>If it exceeds the 15-day deadline.</li>
                    <li style={listItemStyle}>If it was a customer selection error.</li>
                    <li style={listItemStyle}>If a product different from the one reported is sent, the return does not proceed.</li>
                </ul>
            </section>
            
            <section style={sectionStyle}>
                <h2 style={headingStyle}>3. How to request a return:</h2>
                <p style={paragraphStyle}>
                    Send us an email to <span style={contactInfoStyle}>victoria.marin@shimanomexico.com</span> or message via WhatsApp to <span style={contactInfoStyle}>442 582 0239</span> with:
                </p>
                <ul style={listStyle}>
                    <li style={listItemStyle}>Business Name.</li>
                    <li style={listItemStyle}>Product code.</li>
                    <li style={listItemStyle}>Invoice number.</li>
                    <li style={listItemStyle}>Order number.</li>
                    <li style={listItemStyle}>Reason for return</li>
                    <li style={listItemStyle}>Product photographs (if applicable)</li>
                </ul>
            </section>
            
            <section style={sectionStyle}>
                <h2 style={headingStyle}>4. Instructions for sending the product.</h2>
                <p style={paragraphStyle}>
                    Shipping costs for returns are the responsibility of the customer, unless it is due to shipping error, mislabeling or damaged product.
                </p>
            </section>
            
            <section style={sectionStyle}>
                <h2 style={headingStyle}>5. Product Review.</h2>
                <p style={paragraphStyle}>
                    When the product arrives at the plant, the quality control team will review it within a period of no more than 5 business days.
                </p>
                <p style={paragraphStyle}>
                    If the return is APPROVED, the credit note or part exchange is processed, as applicable.
                </p>
                <p style={paragraphStyle}>
                    If it is NOT APPROVED, the customer is notified and reshipment of the product may be offered (with or without cost according to the policy).
                </p>
            </section>
            
            <div style={noteStyle}>
                NOTE: Remember that the return can be avoided if you rely on your advisor or the technical support area for good product advice.
            </div>
        </div>
    );
};

export default PoliticsEN;